// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TLjlHPD343LicrWG7228 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: var(--sl-space-4);
  margin: var(--sl-space-5) 0;
}

/* Com formulário: card de créditos = 1,5× (span 3 vs 2) */
.MEWomaUiwYB7hVwZa7gr {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

.cj3xim7FodwGbK2WmzET {
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-3);
  padding: var(--sl-space-4) var(--sl-space-5);
  min-height: 7.5rem;
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-2);
}

.MEWomaUiwYB7hVwZa7gr .cj3xim7FodwGbK2WmzET {
  grid-column: span 2;
}

.MEWomaUiwYB7hVwZa7gr .l32oZRwY31SxXswcy6Jm {
  grid-column: span 3;
}

@media (max-width: 64rem) {
  .TLjlHPD343LicrWG7228,
  .MEWomaUiwYB7hVwZa7gr {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .MEWomaUiwYB7hVwZa7gr .cj3xim7FodwGbK2WmzET,
  .MEWomaUiwYB7hVwZa7gr .l32oZRwY31SxXswcy6Jm {
    grid-column: span 1;
  }
}

@media (max-width: 40rem) {
  .TLjlHPD343LicrWG7228,
  .MEWomaUiwYB7hVwZa7gr {
    grid-template-columns: minmax(0, 1fr);
  }

  .MEWomaUiwYB7hVwZa7gr .cj3xim7FodwGbK2WmzET,
  .MEWomaUiwYB7hVwZa7gr .l32oZRwY31SxXswcy6Jm {
    grid-column: span 1;
  }
}

.gtCPmauKtzt17ebu_LAJ {
  margin: 0;
  font: var(--sl-text-caption-1-font);
  font-weight: 600;
  color: var(--sl-fg-base-soft);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.mrRpb1crH6_Qfd73beCW {
  margin: 0;
  font: var(--sl-text-display-3-font);
  letter-spacing: var(--sl-letter-spacing-2);
  color: var(--sl-fg-base);
  font-variant-numeric: tabular-nums;
}

.oSCEPK4KnMYofFPPRcot {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: var(--sl-space-2);
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
  flex-wrap: wrap;
}

.kTGM3piblJFHpLCHOF_T {
  margin: 0;
  font: var(--sl-text-body-font);
  color: var(--sl-fg-base-soft);
}

.kTGM3piblJFHpLCHOF_T a {
  color: var(--sl-fg-accent);
  text-decoration: underline;
}

.qb75HSxahXMJW9I74SBL {
  margin: 0;
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
}

.sg92pw7fES9LSvTaRXrS {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
  font: var(--sl-text-emphasis-font);
  font-variant-numeric: tabular-nums;
}

.FVJQZtDjDK7l_KSR9TCN {
  color: var(--sl-fg-critical);
}

.ao2G8zj7Tvjtb_sY2ung {
  color: var(--sl-fg-success);
}

._VoOpF12Bc1L2PC7zSVB {
  color: var(--sl-fg-base-soft);
  font-weight: 400;
}

.ueXz4rr4BjcWTEM0kxBP {
  margin-left: auto;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: var(--sl-radius-2);
  background: transparent;
  color: var(--sl-fg-base-soft);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  padding: 0;
}

.ueXz4rr4BjcWTEM0kxBP:hover {
  background: var(--sl-bg-base-soft);
  color: var(--sl-fg-base);
}

.ueXz4rr4BjcWTEM0kxBP:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-base);
}

.Nd3bxf0eCt08nSf9VE5s {
  display: flex;
  align-items: stretch;
  margin-top: var(--sl-space-2);
  width: 100%;
  min-width: 0;
}

.Nd3bxf0eCt08nSf9VE5s .inputContainer {
  flex: 1 1 auto;
  min-width: 0;
  max-height: 2.375rem;
  width: auto;
  border-radius: var(--sl-radius-2) 0 0 var(--sl-radius-2);
}

.Nd3bxf0eCt08nSf9VE5s button {
  flex: 0 0 auto;
  width: auto;
  min-width: unset;
  height: 2.75rem;
  min-height: 2.75rem;
  padding-inline: var(--sl-space-3);
  white-space: nowrap;
  border-radius: 0 var(--sl-radius-2) var(--sl-radius-2) 0;
}

.ZrxcXapzXDeL48v2Mcdb {
  display: flex;
  align-items: center;
  gap: var(--sl-space-2);
  flex: 1;
  min-width: 0;
}

.eBXuxXffhopnZcRY1Uvf,
.EdC28rToaQajcrCckBm9 {
  display: inline-block;
  padding: var(--sl-space-05, 0.125rem) var(--sl-space-2);
  border-radius: var(--sl-radius-2);
  font: var(--sl-text-caption-1-font);
}

.eBXuxXffhopnZcRY1Uvf {
  background: var(--sl-bg-success-soft, #e8f8ef);
  color: var(--sl-fg-success);
}

.EdC28rToaQajcrCckBm9 {
  background: var(--sl-bg-base-soft);
  color: var(--sl-fg-base-soft);
}

.It3ly0QWZeaoKIvmgmxw {
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
}

.ZHcT4hYw0THB6MECSS_X {
  font-weight: 600;
  color: var(--sl-fg-base);
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/HeaderWalletBalance/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,gDAAgD;EAClD;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,uDAAuD;EACvD,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));\n  gap: var(--sl-space-4);\n  margin: var(--sl-space-5) 0;\n}\n\n/* Com formulário: card de créditos = 1,5× (span 3 vs 2) */\n.gridWithWide {\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n\n.card {\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-3);\n  padding: var(--sl-space-4) var(--sl-space-5);\n  min-height: 7.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-2);\n}\n\n.gridWithWide .card {\n  grid-column: span 2;\n}\n\n.gridWithWide .cardWide {\n  grid-column: span 3;\n}\n\n@media (max-width: 64rem) {\n  .grid,\n  .gridWithWide {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .gridWithWide .card,\n  .gridWithWide .cardWide {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 40rem) {\n  .grid,\n  .gridWithWide {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .gridWithWide .card,\n  .gridWithWide .cardWide {\n    grid-column: span 1;\n  }\n}\n\n.label {\n  margin: 0;\n  font: var(--sl-text-caption-1-font);\n  font-weight: 600;\n  color: var(--sl-fg-base-soft);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.value {\n  margin: 0;\n  font: var(--sl-text-display-3-font);\n  letter-spacing: var(--sl-letter-spacing-2);\n  color: var(--sl-fg-base);\n  font-variant-numeric: tabular-nums;\n}\n\n.foot {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  font: var(--sl-text-caption-1-font);\n  color: var(--sl-fg-base-soft);\n  flex-wrap: wrap;\n}\n\n.copy {\n  margin: 0;\n  font: var(--sl-text-body-font);\n  color: var(--sl-fg-base-soft);\n}\n\n.copy a {\n  color: var(--sl-fg-accent);\n  text-decoration: underline;\n}\n\n.period {\n  margin: 0;\n  font: var(--sl-text-caption-1-font);\n  color: var(--sl-fg-base-soft);\n}\n\n.trend {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  font: var(--sl-text-emphasis-font);\n  font-variant-numeric: tabular-nums;\n}\n\n.trendDebit {\n  color: var(--sl-fg-critical);\n}\n\n.trendCredit {\n  color: var(--sl-fg-success);\n}\n\n.trendEmpty {\n  color: var(--sl-fg-base-soft);\n  font-weight: 400;\n}\n\n.gear {\n  margin-left: auto;\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: var(--sl-radius-2);\n  background: transparent;\n  color: var(--sl-fg-base-soft);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 0;\n  padding: 0;\n}\n\n.gear:hover {\n  background: var(--sl-bg-base-soft);\n  color: var(--sl-fg-base);\n}\n\n.gear:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-base);\n}\n\n.rechargeForm {\n  display: flex;\n  align-items: stretch;\n  margin-top: var(--sl-space-2);\n  width: 100%;\n  min-width: 0;\n}\n\n.rechargeForm :global(.inputContainer) {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-height: 2.375rem;\n  width: auto;\n  border-radius: var(--sl-radius-2) 0 0 var(--sl-radius-2);\n}\n\n.rechargeForm :global(button) {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: unset;\n  height: 2.75rem;\n  min-height: 2.75rem;\n  padding-inline: var(--sl-space-3);\n  white-space: nowrap;\n  border-radius: 0 var(--sl-radius-2) var(--sl-radius-2) 0;\n}\n\n.statusRow {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  flex: 1;\n  min-width: 0;\n}\n\n.statusActive,\n.statusInactive {\n  display: inline-block;\n  padding: var(--sl-space-05, 0.125rem) var(--sl-space-2);\n  border-radius: var(--sl-radius-2);\n  font: var(--sl-text-caption-1-font);\n}\n\n.statusActive {\n  background: var(--sl-bg-success-soft, #e8f8ef);\n  color: var(--sl-fg-success);\n}\n\n.statusInactive {\n  background: var(--sl-bg-base-soft);\n  color: var(--sl-fg-base-soft);\n}\n\n.marketplace {\n  font: var(--sl-text-caption-1-font);\n  color: var(--sl-fg-base-soft);\n}\n\n.marketplaceStrong {\n  font-weight: 600;\n  color: var(--sl-fg-base);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `TLjlHPD343LicrWG7228`,
	"gridWithWide": `MEWomaUiwYB7hVwZa7gr`,
	"card": `cj3xim7FodwGbK2WmzET`,
	"cardWide": `l32oZRwY31SxXswcy6Jm`,
	"label": `gtCPmauKtzt17ebu_LAJ`,
	"value": `mrRpb1crH6_Qfd73beCW`,
	"foot": `oSCEPK4KnMYofFPPRcot`,
	"copy": `kTGM3piblJFHpLCHOF_T`,
	"period": `qb75HSxahXMJW9I74SBL`,
	"trend": `sg92pw7fES9LSvTaRXrS`,
	"trendDebit": `FVJQZtDjDK7l_KSR9TCN`,
	"trendCredit": `ao2G8zj7Tvjtb_sY2ung`,
	"trendEmpty": `_VoOpF12Bc1L2PC7zSVB`,
	"gear": `ueXz4rr4BjcWTEM0kxBP`,
	"rechargeForm": `Nd3bxf0eCt08nSf9VE5s`,
	"statusRow": `ZrxcXapzXDeL48v2Mcdb`,
	"statusActive": `eBXuxXffhopnZcRY1Uvf`,
	"statusInactive": `EdC28rToaQajcrCckBm9`,
	"marketplace": `It3ly0QWZeaoKIvmgmxw`,
	"marketplaceStrong": `ZHcT4hYw0THB6MECSS_X`
};
export default ___CSS_LOADER_EXPORT___;
